var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-1.5 0v-13.5a.75.75 0 0 1 .75-.75Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 11.25a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V12h-13.5v2.25a.75.75 0 0 1-1.5 0v-3ZM18.25 24.75A.75.75 0 0 1 19 24h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
    fill: "#3D4043"
  })));
};
export default SvgText;